import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQSection = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    /* Band 5: pure white — alternates with off-white Why Nura above */
    <section
      className="py-16 md:py-20"
      style={{ background: '#FFFFFF', borderBottom: '1px solid rgba(43,56,121,0.07)' }}
    >
      <div className="container max-w-4xl mx-auto px-6">
        <div className="text-center mb-10">
          <span className="pill-label">FAQs</span>
          <h2
            className="font-extrabold text-[#00001E] mt-2"
            style={{
              fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
              fontSize: 'clamp(1.5rem, 3vw, 2rem)',
              letterSpacing: '-0.02em',
              lineHeight: 1.2,
            }}
          >
            Frequently Asked Questions
          </h2>
        </div>

        <div
          className="rounded-2xl overflow-hidden"
          style={{
            border: '1px solid rgba(43,56,121,0.09)',
            boxShadow: '0 4px 20px rgba(43,56,121,0.07)',
          }}
        >
          {items.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={i}
                style={{
                  background: isOpen ? '#FAFCFF' : '#FFFFFF',
                  borderBottom: i < items.length - 1 ? '1px solid rgba(43,56,121,0.08)' : 'none',
                  transition: 'background 0.2s ease',
                }}
              >
                <button
                  type="button"
                  onClick={() => toggle(i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-7 py-5 text-left"
                  style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                >
                  <h3
                    className="font-semibold"
                    style={{
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                      fontSize: '1rem',
                      lineHeight: 1.4,
                      color: isOpen ? '#2B3879' : '#00001E',
                    }}
                  >
                    {item.q}
                  </h3>
                  <div
                    className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-all duration-300"
                    style={{
                      background: isOpen ? 'rgba(128,229,203,0.20)' : 'rgba(43,56,121,0.06)',
                      border: isOpen ? '1px solid rgba(128,229,203,0.50)' : '1px solid rgba(43,56,121,0.12)',
                    }}
                  >
                    <ChevronDown
                      style={{
                        color: isOpen ? '#00001E' : '#2B3879',
                        width: '15px',
                        height: '15px',
                        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </div>
                </button>

                {isOpen && (
                  <p
                    className="px-7 pb-6 leading-relaxed"
                    style={{
                      color: '#2B3879',
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                      fontSize: '0.97rem',
                      lineHeight: 1.75,
                    }}
                  >
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
